import {
  consentLevelAdvertisingSelector,
  consentLevelFunctionalSelector,
} from 'selectors/cookieConsentSelectors';
import { useSelector } from 'react-redux';
import React from 'react';

interface UseConsentRestrictedScripts {
  consentLevelAdvertising: boolean;
  consentLevelFunctional: boolean;
  scriptAdded: boolean;
  setScriptAdded: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 *
 * Manages boilerplate code for consent restricted scripts components
 */
export const useConsentRestrictedScripts = (): UseConsentRestrictedScripts => {
  const consentLevelAdvertising = useSelector(consentLevelAdvertisingSelector);
  const consentLevelFunctional = useSelector(consentLevelFunctionalSelector);

  const [isScriptSet, setIsScriptSet] = React.useState(false);

  return {
    consentLevelAdvertising,
    consentLevelFunctional,
    scriptAdded: isScriptSet,
    setScriptAdded: setIsScriptSet,
  };
};
